export default "__VITE_ASSET__m7co93Tr__"